/**
 * @documental
 * @export OverlayContainer
 * @import
 * import { OverlayContainer } from "capitalrx-components-2.0/lib/general";
 */

import { FC, useState, useMemo, useCallback, PropsWithChildren } from "react";
import { getHtmlPropsFromBaseProps } from "../../utilities/getHtmlPropsFromBaseProps";
import classNames from "classnames";
import { OverlayContext, OverlayContextValue } from "./OverlayContext";
import { createComponentStyleHook } from "../../tokens";

import legacyStyles from "./legacy/styles.module.scss";
import tokenStyles from "./styles.module.css";

const useStyles = createComponentStyleHook<PropsWithChildren<{}>>({
  legacyStyles,
  tokenStyles,
  componentTokens: "overlay",
});

/**
 * The container for all child `Overlay` instances. Acts as the surface upon which all
 * overlays are placed.
 */
export const OverlayContainer: FC<PropsWithChildren<{}>> = (props) => {
  const { children } = props;
  const { mode, styles, StyleModeBoundary } = useStyles(props);

  const baseHtmlProps = getHtmlPropsFromBaseProps(
    {},
    {
      className: [styles.OverlayContainer, "overlay-container"],
      testIdPrefix: "overlay-container",
    },
  );

  const [element, setElement] = useState<HTMLElement | null>(null);

  const elementRefHandler = useCallback((ref: HTMLDivElement | null) => {
    setElement(ref);
  }, []);

  const contextValue = useMemo(
    (): OverlayContextValue => ({
      element,
    }),
    [element],
  );

  return (
    <StyleModeBoundary mode={mode}>
      <OverlayContext.Provider value={contextValue}>{children}</OverlayContext.Provider>
      <div {...baseHtmlProps}>
        <div ref={elementRefHandler} className={classNames(styles.OverlayContainerContent, "overlay-container-content")} />
      </div>
    </StyleModeBoundary>
  );
};
